import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SEF } from '../../../../app.constants';
import { SEFSaldoFinanceiroModel } from '../../../shared/models/sef-saldo-financeiro.model';

@Injectable()
export class SefService {


    constructor(private httpClient: HttpClient) { }

    getConsultaSaldoDevedor(cdCentrus: number): Promise<SEFSaldoFinanceiroModel[]> {
      return this.httpClient
        .get<SEFSaldoFinanceiroModel[]>(`${SEF}/consultaSaldoDevedor/${cdCentrus}`)
        .toPromise();
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/sef/service/sef.service.ts